import { call, put, takeEvery } from 'redux-saga/effects';
import { trafficStatusMapService } from '../../services';
import {
  getTrafficStatusForMap,
  saveTrafficStatusForMap,
  changeLoading,
  getTrafficStatusForMapV2,
  saveTrafficStatusForMapV2,
  changeLoadingV2,
  getTrafficStatusRectangle,
  saveTrafficStatusRectangle,
  changeLoadingRectangle,
  getTrafficStatusCircle,
  saveTrafficStatusCircle,
  changeLoadingCircle,
} from '../../features/trafficStatusMapSlice';

function* getTrafficStatusMapSaga(action) {
  try {
    yield put(changeLoading(true));
    const response = yield call(
      trafficStatusMapService.getTrafficStatus,
      action.payload
    );
    console.log('response.data', response.data);
    yield put(saveTrafficStatusForMap(response.data));
  } catch (error) {
    console.log(error.message);
    yield put(changeLoading(false));
  }
}

function* getTrafficStatusMapV2Saga(action) {
  try {
    yield put(changeLoadingV2(true));
    const response = yield call(
      trafficStatusMapService.getTrafficStatusV2,
      action.payload
    );
    // console.log('response.data2', response.data);
    yield put(saveTrafficStatusForMapV2(response.data));
  } catch (error) {
    console.log(error.message);
    yield put(changeLoadingV2(false));
  }
}

function* getTrafficStatusRectangleSaga(action) {
  try {
    yield put(changeLoadingRectangle(true));
    const response = yield call(
      trafficStatusMapService.getTrafficStatusRectangle,
      action.payload
    );
    yield put(saveTrafficStatusRectangle(response.data));
  } catch (error) {
    console.log(error.message);
    yield put(changeLoadingRectangle(false));
  }
}

function* getTrafficStatusCircleSaga(action) {
  try {
    yield put(changeLoadingCircle(true));
    const response = yield call(
      trafficStatusMapService.getTrafficStatusCircle,
      action.payload
    );
    yield put(saveTrafficStatusCircle(response.data));
  } catch (error) {
    console.log(error.message);
    yield put(changeLoadingCircle(false));
  }
}


export default function* trafficStatusMap() {
  yield takeEvery(getTrafficStatusForMap, getTrafficStatusMapSaga);
  yield takeEvery(getTrafficStatusForMapV2, getTrafficStatusMapV2Saga);
  yield takeEvery(getTrafficStatusRectangle, getTrafficStatusRectangleSaga);
  yield takeEvery(getTrafficStatusCircle, getTrafficStatusCircleSaga);
}
